/** Keeps #app the size of the visible area, since WKWebView pans the document instead of resizing it when the keyboard opens. */
export function pinViewport(): void {
  const vv = window.visualViewport;
  if (!vv) return;

  const root = document.documentElement;
  // Keyboard-down height per orientation. Not `innerHeight` (WKWebView doesn't update it) and
  // not focus (autoFocus focuses without opening the keyboard).
  // TODO(scope): an orientation first entered with the keyboard already up reads as closed
  // until the keyboard is dismissed once in it.
  const fullHeights = new Map<number, number>();
  const sync = () => {
    const width = Math.round(vv.width);
    const fullHeight = Math.max(fullHeights.get(width) ?? 0, vv.height);
    fullHeights.set(width, fullHeight);
    root.style.setProperty("--app-height", `${vv.height}px`);
    root.dataset.keyboard = fullHeight - vv.height > 120 ? "open" : "closed";
    if (window.scrollY !== 0 || window.scrollX !== 0) window.scrollTo(0, 0);
    root.style.setProperty("--vv-offset-top", `${vv.offsetTop}px`);
    root.style.setProperty("--vv-offset-left", `${vv.offsetLeft}px`);
  };

  vv.addEventListener("resize", sync);
  vv.addEventListener("scroll", sync);
  window.addEventListener("scroll", sync, { passive: true });
  sync();
}
